import { getPracticeMemberUsage } from '@nesso/reporting-contracts/practice-member-reporting.queries';

export const practiceMemberUsageInputSchema = getPracticeMemberUsage.input;
export const practiceMemberUsageOutputSchema = getPracticeMemberUsage.output;

export const practiceMemberUsageSortBySchema = getPracticeMemberUsage.input.shape.sortBy;
export const practiceMemberUsageSortDirectionSchema =
    getPracticeMemberUsage.input.shape.sortDirection;
export const practiceMemberUsageSummarySchema =
    getPracticeMemberUsage.output.shape.summary.unwrap();
